import { css } from "../../../../styled-system/css";
import { VStack } from "../../../../styled-system/jsx";
import { useAppSelector } from "../../../redux/hooks";
import { formatMetricValue, type FormatOptions } from "../../../utils/formatNumber";
import type { CompareHighlight } from "../../../views/merchandise/metrics";

interface Props {
  value: number | null;
  compareValue?: number | null;
  formatOptions?: FormatOptions;
  compareFormatOptions?: FormatOptions;
  compareHighlight?: CompareHighlight;
}
export function MetricCell({
  value,
  formatOptions = {
    format: "number",
    default: "-",
    rounded: "down",
    compact: true,
    addPlus: false,
    decimalPlaces: 1,
  },
  compareValue,
  compareFormatOptions = {
    format: "number",
    default: "-",
    rounded: "down",
    compact: true,
    addPlus: true,
    decimalPlaces: 1,
  },
  compareHighlight = "positiveIsGood",
}: Props) {
  let marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  if (formatOptions.overrideMarketplace) {
    marketPlace = formatOptions.overrideMarketplace;
  }

  const displayValue = formatMetricValue(value, formatOptions, marketPlace);
  const displayCompareValue = formatMetricValue(compareValue, compareFormatOptions, marketPlace);

  return (
    <VStack gap={"xsmall"} alignItems={"end"} width={"100%"} paddingY="xsmall" paddingX={"small"} lineHeight={"1"}>
      <span>{displayValue}</span>
      <span
        className={css({
          color:
            (
              (compareHighlight === "positiveIsGood" && (compareValue ?? 0) > 0) ||
              (compareHighlight === "negativeIsGood" && (compareValue ?? 0) < 0)
            ) ?
              "trellisPalette.12"
            : (
              (compareHighlight === "positiveIsGood" && (compareValue ?? 0) < 0) ||
              (compareHighlight === "negativeIsGood" && (compareValue ?? 0) > 0)
            ) ?
              "trellisPalette.17"
            : "inherit",
          fontSize: "small",
          fontWeight: "bold",
        })}
      >
        {displayCompareValue}
      </span>
    </VStack>
  );
}
